import * as actionTypes from '../actions/ActionTypes'

export default function(state = [], action) {
  switch (action.type) { 
    case actionTypes.LISTS_EMAIL_HOTALERT_CHECK_UPDATE:
      return action.listsEmailHotAlertCheck 
    default:
      return state
  }
}

